import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// LIST ALL GROUPS
export const groupList = (params = '') => Http.get(`/marketing-kpi-groups${serialize(params)}`)
export const groupCreate = (params = '') => Http.post('/marketing-kpi-groups', params)
export const groupByID = (params = '') => Http.get(`/marketing-kpi-groups/${params}`)
export const groupUpdate = (params = '') => Http.put(`/marketing-kpi-groups/${params.id}`, params)
export const groupDestroy = (params = '') => Http.delete(`/marketing-kpi-groups/${params.id}`)
   